$(function(){

  function addUpdateIconNav() {
    $('#mainnav .menu .news').next('.update').remove();
    $('#mainnav .menu .news').after('<span class="update">Updates</span>');
  }

  // セッションストレージ確認
  var updateNews = window.sessionStorage.getItem('updateNews');
  if ( updateNews == 'true' || updateNews == true ) {
    addUpdateIconNav();
    if (!$('body').hasClass('checknews')) {
      return false; //TOPとNEWS一覧以外は、strageにあれば処理終了
    }
  }

  $.ajax({
    type: 'GET',
    // url: 'https://www.nodamap.com/news/sakuranomori/?json=get_category_posts&slug=sakuranomori&count=5',
    url: '/news/sakuranomori/?json=get_category_posts&slug=sakuranomori&count=5',
    dataType: 'jsonp',
    success: function(json){

      var newsHtml = '<ul class="recent-news">';
      for(var i=0; i < json.posts.length; i++){

        var post = json.posts[i];

        //最新1件だけ確認
        if (i == 0) {
          var last = moment(post.date).utc();
          var now = moment().utc();
          var diff = now.diff(last, 'hours', true);
          if (diff < 72) { //3日以内
            window.sessionStorage.setItem('updateNews',true); //登録
            addUpdateIconNav();
          } else {
            window.sessionStorage.setItem('updateNews',false);
          }
        }

        var date = post.date.slice(0,10);
        var dateYear = date.slice(0,4);
        var dateMonth = date.slice(5,7);
        var dateDay = date.slice(8,10);

        // newsHtml += '<li><a href="/news/sakuranomori/#post-'+json.posts[i].id+'">';
        newsHtml += '<li><a href="/news/sakuranomori/'+post.id+'/">';
        newsHtml += '<time datetime="'+date+'">'+dateYear+'.'+dateMonth+'.'+dateDay+'</time>';
        newsHtml += '<span>'+post.title+'</span></a></li>';
      }

      newsHtml += '</ul>';

      // DOM生成
      var $sec = $('.toppage #news');
      if($sec.length > 0){
        $sec.append(newsHtml);
      }

    }
  });


});
